
import React from 'react';
import CampaignRecipientInfoComponent, { CompaignRecipientInfoComponent } from './campaign-recipient-info.component';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/form.module';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';
import Table from '../../../../../../../common/components/table';
import EmailPlansListContainer from './containers/plans-templates-list.container';

export const CampaignEmailInfoComponent = ({
  agents,
  paginationData,
  setPageData,
  rowData,
  columnDefs,
  onPlanIdChange,
  choosenTemplate,
  choosenCampaign,
  campaignFrequency,
  customerTags,
  choosenEmailPlan,
  emailBudget,
  emailNotes,
  setSelectedTemplate,
  selectedTemplate,
  handlePlanSelect,
  handleInnerFormChange,
  vendorRowData,
  VendorpaginationData,
  vendorColumnDefs
}: any) => {

  const tabItems=[
    {
        id:1,
        title:'Recipient',
        component:   <CompaignRecipientInfoComponent
        choosenEmailPlan={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange}
        customerTags={customerTags}
      />,
    isVisible:true ,
    },
  ]
  return (
    <>
      <AccordionContainer
        child={
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'Name');
                }}
                type="text"
                value={choosenCampaign?.Name}
              />
        
              <InputContainer
                label="Campaign Frequency"
                labelField="Text"
                list={campaignFrequency}
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'FrequencyId');
                }}
                optionName='Choose Campaign Frequency'
                type="select"
                value={choosenCampaign?.FrequencyId}
                valueField="Value"
              />
          
              <InputContainer
                isDateTimePicker
                label="Start Date"
                name="StartDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'StartDate');
                }}
                type="date"
                value={choosenCampaign?.StartDate}
              />
           
              <InputContainer
                isDateTimePicker
                label="End Date"
                name="EndDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'EndDate');
                }}
                type="date"
                value={choosenCampaign?.EndDate}
              />
           </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

<AccordionContainer
        child={
          <TabContainer tabItems={tabItems} />
        }
        expandedPanel="Email Campaign Receipient Info"
        headerTitle="Email Campaign Receipient Info"
      />
    <AccordionContainer
        child={
          <EmailPlansListContainer 
            choosenCampaign={choosenCampaign}
            handleInnerFormChange={handleInnerFormChange} 
            campaignFrequency={campaignFrequency}
            customerTags={customerTags}
            emailNotes={emailNotes}
            emailBudget={emailBudget}
            choosenEmailPlan={choosenEmailPlan}   
            onPlanIdChange={onPlanIdChange}
            setSelectedTemplate={setSelectedTemplate}
            selectedTemplate={selectedTemplate}   
            choosenTemplate={choosenTemplate}
            onSelect={handlePlanSelect}
          />
          
        }
        expandedPanel="Plans"
        headerTitle="Select a Plan"
      />

    </>
  );
};
export default CampaignEmailInfoComponent;
